import React from 'react';
import { Check, CreditCard } from 'lucide-react';
import { Button } from './ui/button';
import { pricingData } from '../data/mock';

const Pricing = ({ onNavigate }) => {
  return (
    <section id="pricing" className="py-20 bg-gradient-to-br from-green-50 via-yellow-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Un Prix Simple et Transparent
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Pas d'abonnement, pas de frais cachés. Payez uniquement quand vous en avez besoin.
          </p>
        </div>

        <div className="max-w-md mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-yellow-400 transform hover:scale-105 transition-all duration-300">
            {/* Badge */}
            <div className="bg-yellow-500 text-center py-3">
              <span className="text-gray-900 font-bold text-sm uppercase tracking-wider">
                Prix Imbattable
              </span>
            </div>
            
            {/* Price */}
            <div className="p-10 text-center bg-gradient-to-br from-white to-yellow-50">
              <div className="mb-6">
                <span className="text-6xl font-bold text-gray-900">{pricingData.price}</span>
                <span className="text-gray-600 text-xl ml-2">{pricingData.duration}</span>
              </div>
              
              <p className="text-gray-600 text-lg mb-8">
                Restez connecté sans vous ruiner
              </p>
              
              <Button 
                size="lg" 
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold text-lg py-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
                onClick={() => onNavigate('locations')}
              >
                Trouver une Borne Maintenant
              </Button>
            </div>
            
            {/* Features */}
            <div className="p-10 bg-white">
              <div className="space-y-4">
                {pricingData.features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-3 group">
                    <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-green-500 transition-colors duration-300">
                      <Check className="w-4 h-4 text-green-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <span className="text-gray-700 leading-relaxed">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Additional info */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2">
            <CreditCard className="w-5 h-5 text-gray-600" />
            <p className="text-gray-600">
              Paiement sécurisé par carte bancaire ou mobile
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
